var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vacancy-basic"},[_c('vtitle'),_vm._v(" "),(_vm.modules.length)?_c('vmodules',{attrs:{"type":"vacancy","label":_vm.$tr('vacancy.basic.form.modules.label'),"modules":_vm.enabledModules},on:{"toggle":_vm.set_is_active}}):_vm._e(),_vm._v(" "),_c('settings',{attrs:{"modules":_vm.enabledModules}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }